import React from "react";
import { RefreshCw, X } from "lucide-react";
import { useSiteRelease } from "../hooks/useSiteRelease";
import "../site-update.css";

export const SiteUpdateNotice = ({ hidden = false }) => {
  const update = useSiteRelease();
  if (hidden || !update.visible) return null;
  return <aside className="site-update-notice" data-testid="site-update-notice" role="status" aria-live="polite">
    <RefreshCw size={18} aria-hidden="true" />
    <div><p data-testid="site-update-title">A newer version is available.</p><span data-testid="site-update-message">{update.blocked ? "Your current work is safe. Finish or close it before refreshing." : "Refresh to load the latest site."}</span>
      <button type="button" data-testid="site-update-refresh" disabled={update.blocked} onClick={update.refresh}><RefreshCw size={13} />Refresh site</button>
    </div>
    <button type="button" className="site-update-later" data-testid="site-update-later" title="Later" aria-label="Remind me on a future visit" onClick={update.later}><X size={16} /></button>
  </aside>;
};